/**
 * Composant pour la saisie d'adresse internationale
 * Utilisé pour tous les pays sauf le Sénégal
 */

import './InternationalAddressInput.css';

function InternationalAddressInput({
  state,
  city,
  postalCode,
  addressLine,
  quartier,
  onChange,
  errors = {},
  required = true
}) {
  const handleChange = (field, value) => {
    if (onChange) {
      onChange({
        [field]: value,
        // Pour les pays internationaux, on met null pour les IDs sénégalais
        region_id: null,
        department_id: null,
        commune_id: null,
        // Préserver le quartier si c'est un autre champ qui change
        ...(field !== 'quartier' && quartier ? { quartier } : {}),
      });
    }
  };

  return (
    <div className="international-address-input">
      {/* Ligne d'adresse */}
      <div className="form-group">
        <label htmlFor="address_line">Adresse</label>
        <input
          type="text"
          id="address_line"
          name="address_line"
          value={addressLine || ''}
          onChange={(e) => handleChange('address_line', e.target.value)}
          className={`form-control ${errors.address_line ? 'error' : ''}`}
          placeholder="Rue, numéro, etc. (optionnel)"
          maxLength={200}
        />
        {errors.address_line && <div className="field-error">{errors.address_line}</div>}
        <small className="form-hint">Optionnel - Numéro de rue, nom de rue, etc.</small>
      </div>

      {/* Quartier / Village */}
      <div className="form-group">
        <label htmlFor="quartier">Quartier / Village</label>
        <input
          type="text"
          id="quartier"
          name="quartier"
          value={quartier || ''}
          onChange={(e) => handleChange('quartier', e.target.value)}
          className={`form-control ${errors.quartier ? 'error' : ''}`}
          placeholder="Nom du quartier ou village (optionnel)"
          maxLength={200}
        />
        {errors.quartier && <div className="field-error">{errors.quartier}</div>}
        <small className="form-hint">Optionnel - Nom du quartier, village ou hameau</small>
      </div>

      {/* Ville */}
      <div className="form-group">
        <label htmlFor="city">
          Ville {required && <span className="required">*</span>}
        </label>
        <input
          type="text"
          id="city"
          name="city"
          value={city || ''}
          onChange={(e) => handleChange('city', e.target.value)}
          className={`form-control ${errors.city ? 'error' : ''}`}
          placeholder="Ex: Paris, New York, Toronto..."
          required={required}
          maxLength={100}
        />
        {errors.city && <div className="field-error">{errors.city}</div>}
      </div>

      {/* État/Province — optionnel (PRD: ville obligatoire, état optionnel) */}
      <div className="form-group">
        <label htmlFor="state">État/Province</label>
        <input
          type="text"
          id="state"
          name="state"
          value={state || ''}
          onChange={(e) => handleChange('state', e.target.value)}
          className={`form-control ${errors.state ? 'error' : ''}`}
          placeholder="Ex: Île-de-France, California, Ontario..."
          maxLength={100}
        />
        {errors.state && <div className="field-error">{errors.state}</div>}
        <small className="form-hint">Optionnel — État, province ou région administrative</small>
      </div>

      {/* Code Postal — optionnel */}
      <div className="form-group">
        <label htmlFor="postal_code">Code Postal</label>
        <input
          type="text"
          id="postal_code"
          name="postal_code"
          value={postalCode || ''}
          onChange={(e) => handleChange('postal_code', e.target.value)}
          className={`form-control ${errors.postal_code ? 'error' : ''}`}
          placeholder="Ex: 75001, 10001, M5H 2N2..."
          maxLength={20}
        />
        {errors.postal_code && <div className="field-error">{errors.postal_code}</div>}
        <small className="form-hint">Optionnel</small>
      </div>
    </div>
  );
}

export default InternationalAddressInput;
